import { createReducer, on } from "@ngrx/store";
import { promptsActions } from "./prompts.actions";
import { AiInsightState } from "../ai-insight.state";
import { cloneDeep } from "lodash-es";

export const promptsReducer = createReducer<AiInsightState['prompts']>(
  [],
  on(promptsActions.loadedPrompts, (_state, { prompts }) => cloneDeep(prompts)),
  on(promptsActions.addPrompt, (state, { prompt }) => {
    const existingPromptIndex = state.findIndex(existingPrompt => existingPrompt.promptId === prompt.promptId);
    if (existingPromptIndex !== -1) {
      const updatedPrompts = cloneDeep(state);
      updatedPrompts[existingPromptIndex] = prompt;
      return updatedPrompts;
    } else {
      return [...state, prompt];
    }
  }),
  on(promptsActions.removePrompt, (state, { promptId }) => {
    const existingPromptIndex = state.findIndex(existingPrompt => existingPrompt.promptId === promptId);
    if (existingPromptIndex !== -1) {
      const updatedPrompts = cloneDeep(state);
      updatedPrompts.splice(existingPromptIndex, 1);
      return updatedPrompts;
    } else {
      return state;
    }
  }),
  on(promptsActions.patchPrompt, (state, { promptId, deltaPrompt }) => {
    const existingPromptIndex = state.findIndex(existingPrompt => existingPrompt.promptId === promptId);
    if (existingPromptIndex !== -1) {
      const updatedItem = {
        ...state[existingPromptIndex],
        ...deltaPrompt,
      };

      const updatedItems = cloneDeep(state);
      updatedItems[existingPromptIndex] = updatedItem;

      return updatedItems;
    }

    return state;
  })
);
